import { required, requiredIf } from "vuelidate/lib/validators";
import { date, dateAfter } from "@/validation/";
import moment from "moment";

const step3 = [
  "form.range",
  "form.rangeLocation",
  "form.q_3_2",
  "form.q_3_3",
  "form.locations"
];

const requireRange = function(m) {
  return this.form.range != "national";
};

const requireTypeOther = function(m) {
  return m.type === "other";
};

const requireFeatures = function(m) {
  return m.features.indexOf("other") >= 0;
};

const requireTypeStars = function(m) {
  return ["hotel_1", "hotel_2"].indexOf(m.type) >= 0;
};

const rangeLocation = function(m, form) {
  return form.range === "regional" ? m.length >= 2 && m.length <= 4 : true;
};

const locationDateStart = function(value) {
  const form = this.form;
  return (
    !value ||
    moment(value).isBetween(
      form.date[0].dateStart,
      form.date[0].dateEnd,
      null,
      "[]"
    )
  );
};

const locationDateEnd = function(value) {
  const form = this.form;
  return (
    !value ||
    moment(value).isBetween(
      form.date[0].dateStart,
      form.date[0].dateEnd,
      null,
      "[]"
    )
  );
};

const minLocationsLength = function(locations, event) {
  return this.form.q_3_3 === true || this.form.locations.length > 1;
};

const locationRequireDate = function(value, event) {
  return this.form.q_3_3 !== true;
};

const step3Validations = {
  range: { required },
  rangeLocation: { required: requiredIf(requireRange), rangeLocation },
  q_3_2: { required },
  q_3_3: { required },
  locations: {
    required,
    minLocationsLength,
    $each: {
      name: { required },
      city: { required },
      type: { required },
      typeStars: { required: requiredIf(requireTypeStars) },
      typeOther: { required: requiredIf(requireTypeOther) },
      features: { required },
      featuresOther: { required: requiredIf(requireFeatures) },
      isCentral: { required },
      easyAccess: { required },
      dateStart: {
        required: requiredIf(locationRequireDate),
        date,
        locationDateStart
      },
      dateEnd: {
        required: requiredIf(locationRequireDate),
        date,
        locationDateEnd,
        dateAfterDateStart: dateAfter("dateStart")
      }
    }
  }
};

export { step3Validations, step3 };
